import { Tabs, TextField, Typography, Tab, makeStyles, Checkbox, FormControlLabel, Button, Divider } from "@material-ui/core";
import { useMemo, useState, useRef } from "react";
import TabPanel from "../../Common/TabPanel";
import QuickRouting from "./QuickRouting";
import RegularRouting from "./RegularRouting";
import StartEndLocation from "./StartEndLocation";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    content: {
        paddingTop: theme.spacing(1), 
        marginTop: theme.spacing(1)
    },
    dateSelectBetween : {
        alignSelf: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));


function RouteToolbar(props){
    const {handleQuickRouting, 
        routePlanner, 
        handleStartBatchRoute,
        currentMapMode
    } = props

    const classes = useStyles();
    const {t} = useTranslation('mapManagement');
    const saveTabValue = useRef(0);
    const [tabValue, setTabValue] = useState(saveTabValue.current);
    console.log(saveTabValue.current)

    const StartEndLocationMemo = useMemo(()=>{
        return (
            <StartEndLocation 
                startLocation={routePlanner.start}
                endLocation={routePlanner.end}
                mapMode={currentMapMode}
                handleMapModeChange={props.handleMapModeChange}
                containerStyle={classes.content}
            />
        )
    }, [routePlanner, currentMapMode])

    return (
        <div style={{flexGrow: 1}}>
            <Tabs
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                value={tabValue}
                onChange={(e, newValue)=>{setTabValue(newValue); saveTabValue.current = newValue}}
            >
                <Tab label={t('normal_routing')}/>
                <Tab label={t('quick_routing')}/>
            </Tabs>
            <Divider />
                {StartEndLocationMemo}
            <TabPanel value={tabValue} index={0}>
                <RegularRouting 
                    onSave={props.onSave}
                    handleQuickRouting={handleQuickRouting}
                    handleRoutePreview={props.handleRoutePreview}
                    style={{paddingTop: 16}}
                />
            </TabPanel>
            <TabPanel value={tabValue} index={1} >
                <QuickRouting 
                    handleStartBatchRoute={handleStartBatchRoute}
                />
            </TabPanel>
        </div>
    )
}

RouteToolbar.defaultProps = {
    routePlanner: {}
}

export default RouteToolbar